// extracted by mini-css-extract-plugin
module.exports = {"alert":"login-alert_alert__yjTda","message":"login-alert_message__JwKYg","link":"login-alert_link__VGN7v"};